import { ComunicazioneDTO } from '@framework/api-client';
import * as React from 'react';
import { CommunicationUserTypeTag } from '../CommunicationUserTypeTag';
import { CommunicationLogic } from '../logic/CommunicationLogic';
import { CommunicationActorsContainer } from './CommunicationActorsContainer';
import { CommunicationRecipient } from './CommunicationRecipient';
import { UserName } from './UserName';

export interface ICommunicationActorsViewProps {
  communication: ComunicazioneDTO | null | undefined;
}

/**
 * Attori di una comunicazione
 */
export function CommunicationActorsView(props: ICommunicationActorsViewProps) {
  const { communication } = props;
  if (!communication) return null;

  const sender = CommunicationLogic.sender(communication);
  const recipients = CommunicationLogic.allRecipients(communication);

  return (
    <CommunicationActorsContainer
      showDivider={false}
      from={
        <UserName
          name={sender?.denominazione}
          tag={
            <CommunicationUserTypeTag
              mini
              type={communication.tipoComunicazione?.tipoMittente?.codice}
            />
          }
        />
      }
      to={recipients?.map(recipient => (
        <CommunicationRecipient
          key={recipient.id}
          recipient={recipient}
          communication={communication}
        />
      ))}
    />
  );
}
